// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"

import { colors } from "../../utils/theme/colors"
import { fontWeights } from "../../utils/theme/font-weights"
import Paragraph from "./action-realisees-paragraph"

const SuccessClientSection3 = ({
  title,
  paragraph1,
  paragraph2,
  paragraph3,
  paragraph4,
  paragraph5,
}) => {
  return (
    <div
      sx={{
        display: `flex`,
        flexDirection: `column`,
      }}
    >
      <p
        sx={{
          color: colors.code.secondary,
          fontSize: `1.375rem`,
          fontWeight: fontWeights.black,
        }}
      >
        {title}
      </p>
      <div sx={{ display: `flex` }}>
        <div
          sx={{
            height: `78%`,
            border: `1px solid #b7b7b7`,
            marginTop: `6%`,
            marginRight: [`0px`, `0px`, `-1.5%`, `-1.5%`],
          }}
        />
        <div>
          <Paragraph number={"1"} text={paragraph1} />
          <Paragraph number={"2"} text={paragraph2} />
          <Paragraph number={"3"} text={paragraph3} />
          <Paragraph number={"4"} text={paragraph4} />
          <Paragraph number={"5"} text={paragraph5} />
        </div>
      </div>
    </div>
  )
}

export default SuccessClientSection3
